import React from 'react';
import { TextField, FieldProps, useRecordContext } from 'react-admin';

interface ExistingCustomerFieldProps extends FieldProps {
  source?: string;
}

/**
 * 既存顧客フラグの表示
 * - true  → 「⚪︎」（既存顧客）
 * - false → 「×」（新規顧客）
 * - null / undefined → 空欄（未判定）
 */
const ExistingCustomerField: React.FC<ExistingCustomerFieldProps> = (props) => {
  const { source = 'isExistingCustomer', ...rest } = props;
  const record = useRecordContext(props);
  if (!record) return null;

  const value = record[source];
  let text = '';
  if (value === true) text = '〇';
  else if (value === false) text = '✕';

  return <TextField {...rest} source={source} record={{ ...record, [source]: text }} />;
};

export const formatExistingCustomerForCsv = (value: boolean | null | undefined): string => {
  if (value === true) return '〇';
  if (value === false) return '✕';
  return '';
};

export default ExistingCustomerField;
